(function () {
    "use strict";

    function InterviewAvailabilityForm(scope, InterviewDataService, InterviewViewService) {
        var self = this;
        var formName = "interview-availability-form";
        var _protected = BaseForm.call(self, formName, scope);

        self.data = {};

        self.load = function (formData) {
            self.data.copy_availability_weeks = 1;
            self.data.copy_availability_enabled = false;
            scope.component.copy_availability_weeks = 1;
        };

        self.initCalender = function () {
            self.interviewAvailabilityMode = scope.component.mode;
        }

        self.save = function () {
            var deferred = $q.defer();
            deferred.resolve(self.data);
            return deferred.promise;
        };

        self.handleCopyAvailabilityEnabledChange = function () {
            if (!self.data.copy_availability_enabled) {
                self.validator.validation['copy_availability_weeks'].errors = {};
                scope.$digest();
            }
        };

        self.validator.validateCustom = function (field, optionsField, rule, showError) {
            var name = field.attr("name");
            var value = self.validator.getFieldValue(field);

            switch (rule.name) {
                case "past-week-date":
                    if (moment(scope.component.ends_on_value).isSameOrBefore(moment(scope.component.weeklyRange.to.format("MMMM DD, YYYY")))) {
                        return false;
                    }
                    break;

                case "copy-slots":
                    var slots = scope.component.getCopiedSlots();
                    if (!slots.length) {
                        self.validator.validation[name].errors[rule.name] = true;
                        return false;
                    }
                    break;
            }

            return true;
        };
    }

    angular
        .module('harriApp.interviewV2')
        .service('InterviewAvailabilityForm', [
            'InterviewDataService',
            'InterviewViewService',
            function (InterviewDataService, InterviewViewService) {

                return function (scope) {
                    return new InterviewAvailabilityForm(scope, InterviewDataService, InterviewViewService);
                }
            }]);
})();
